export default class ProfessionTypeValidator {
    static isAnswerCorrect(answer) {
        return true
    }
}

